import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['note', 'toggleIcon'];

  noteTargetConnected(element) {
    let candidate = element.previousElementSibling;
    if (!candidate) return;

    for (var attempts = 0; attempts < 3; attempts++) {
      if (candidate.nodeName == 'P') break;
      if (candidate.previousElementSibling == null) break;

      candidate = candidate.previousElementSibling;
    }
    if (candidate.dataset.withAuthorNote) candidate = null;

    if (candidate !== null) {
      ['opened', 'closed'].forEach((type) => {
        const icon = element.querySelector(`.js-toggle-${type}-icon`);
        candidate.appendChild(icon);
        if (type === 'opened') {
          icon.classList.add('hidden');
        }
        candidate.dataset.withAuthorNote = true;
      });
    } else {
      element.classList.add('hidden');
    }
  }

  toggle(event) {
    const isOpening = event.params.open;
    const toggleIconContainer = event.currentTarget.parentNode;
    const closedIcon = toggleIconContainer.querySelector(
      '.js-toggle-opened-icon'
    );
    const openedIcon = toggleIconContainer.querySelector(
      '.js-toggle-closed-icon'
    );
    closedIcon.classList.toggle('hidden', !isOpening);
    openedIcon.classList.toggle('hidden', isOpening);
    let nextAuthorNote = toggleIconContainer.nextElementSibling;

    for (var attempts = 0; attempts < 3; attempts++) {
      if (nextAuthorNote.classList.contains('js-author-note')) break;
      if (nextAuthorNote.nextElementSibling == null) break;

      nextAuthorNote = nextAuthorNote.nextElementSibling;
    }

    if (nextAuthorNote !== null) {
      toggleIconContainer.classList.toggle('is-displaying-author-note');
      nextAuthorNote.classList.toggle('hidden');
    }
  }
}
